var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "studentsSettings" }, [
    !!_vm.message.message
      ? _c(
          "div",
          {
            staticClass: "alert",
            class: {
              "alert-success": _vm.message.status === "success",
              "alert-danger": _vm.message.status === "danger"
            }
          },
          [_vm._v("\n\t\t" + _vm._s(_vm.message.message) + "\n\t")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isRequestAccess
      ? _c(
          "div",
          [
            _c("h2", [
              _vm._v(
                _vm._s(
                  _vm.$t("MAIN_CONTENT.Students.requestAccessToOterStudents")
                )
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.Students.studentsDetailOnWhatToEnter")
                  ) +
                  "\n\t\t"
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.requestStudents, function(requestStudent, index) {
              return _c(
                "div",
                { key: "student-" + index, attrs: { id: "student-" + index } },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-10" }, [
                      _c("h3", [
                        _vm._v(
                          "\n\t\t\t\t\t\t#" +
                            _vm._s(index + 1) +
                            " Student\n\t\t\t\t\t"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        index
                          ? _c("font-awesome-icon", {
                              staticStyle: { cursor: "pointer" },
                              attrs: { icon: "times" },
                              on: {
                                click: function($event) {
                                  return _vm.removeStudent(index)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("ValidationProvider", {
                          attrs: {
                            name: "first name",
                            rules: "required|min:2"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c("div", {}, [
                                    _c(
                                      "label",
                                      { attrs: { for: "firstName" + index } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.Students.firstNameWithColon"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: requestStudent.firstName,
                                          expression: "requestStudent.firstName"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "firstName" + index,
                                        "data-vv-as": "first name",
                                        name: "firstNames"
                                      },
                                      domProps: {
                                        value: requestStudent.firstName
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            requestStudent,
                                            "firstName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  ])
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "last name", rules: "required|min:2" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c("div", {}, [
                                    _c(
                                      "label",
                                      { attrs: { for: "lastName" + index } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.Students.lastNameWithColon"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: requestStudent.lastName,
                                          expression: "requestStudent.lastName"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "lastName" + index,
                                        "data-vv-as": "last name",
                                        name: "lastNames"
                                      },
                                      domProps: {
                                        value: requestStudent.lastName
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            requestStudent,
                                            "lastName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  ])
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("label", { attrs: { for: "birthday_" + index } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("MAIN_CONTENT.Students.birthdayWithColon")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("date-picker", {
                          ref: "studentBirthday",
                          refInFor: true,
                          attrs: {
                            name: "birthday_" + index,
                            "aria-label": _vm.$t(
                              "MAIN_CONTENT.Students.birthdayWithColon"
                            ),
                            describedByID: "weekOfDateInput",
                            datePickerInputMessage: _vm.$t(
                              "MAIN_CONTENT.Students.birthdayDatepickerAccessibilityMessage"
                            ),
                            label: _vm.$t(
                              "MAIN_CONTENT.Students.birthdayWithColon"
                            ),
                            locale: _vm.getLocaleCode(),
                            validateInput: true,
                            validationName: "birthday",
                            validationInputRules:
                              "required|date_format:dd/mm/yyyy",
                            format: "MM/DD/YYYY",
                            lang: "en",
                            showLabel: false,
                            clearable: false
                          },
                          model: {
                            value: requestStudent.birthday,
                            callback: function($$v) {
                              _vm.$set(requestStudent, "birthday", $$v)
                            },
                            expression: "requestStudent.birthday"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("label", { attrs: { for: "grade" + index } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.commonContent.sideMenuGradeLabel"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: requestStudent.grade,
                              expression: "requestStudent.grade"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { id: "grade" + index, name: "grades" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                requestStudent,
                                "grade",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.gradelevels, function(grade, gradeIndex) {
                          return _c(
                            "option",
                            {
                              key: "school_" + gradeIndex,
                              domProps: { value: grade.GRADE_LEVEL }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(grade.GRADE_LEVEL_DESC) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("label", { attrs: { for: "school" + index } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.Students.schoolWithColon")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: requestStudent.school,
                              expression: "requestStudent.school"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { id: "school" + index, name: "schools" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                requestStudent,
                                "school",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.schools, function(school, schoolIndex) {
                          return _c(
                            "option",
                            {
                              key: "school_" + schoolIndex,
                              domProps: { value: school.SCHOOL_ID }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(school.SCHOOL_TITLE) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  index < _vm.requestStudents.length - 1 ? [_c("hr")] : _vm._e()
                ],
                2
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row text-center" }, [
              _c(
                "button",
                { staticClass: "btn btn-info", on: { click: _vm.addStudent } },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "plus", "aria-hidden": "true" }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("MAIN_CONTENT.Students.addAnotherStudent")
                      ) +
                      "\n\t\t\t"
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row text-center" }, [
              _c(
                "button",
                { staticClass: "btn btn-default", on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("commonText.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { disabled: _vm.invaildStudentAccessRequest },
                  on: { click: _vm.requestNewStudents }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.$t("MAIN_CONTENT.Students.submitRequestTitleCase")
                      ) +
                      "\n\t\t\t"
                  )
                ]
              )
            ])
          ],
          2
        )
      : !_vm.isRequestAccess && !_vm.isCreatingAccount
      ? _c("div", [
          _c("h2", [
            _vm._v(
              _vm._s(_vm.$t("MAIN_CONTENT.Students.manageStudentsTitleCase"))
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row students-list" },
            _vm._l(_vm.students, function(student) {
              return _c(
                "div",
                {
                  key: student.STUDENT_ID,
                  staticClass: "col-xs-12 col-md-6 student-field"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-5 col-md-6 col-lg-5 photo-name"
                      },
                      [
                        _c("img", {
                          staticClass: "media-object",
                          attrs: {
                            src: student.PHOTO_URL,
                            alt: student.FIRST_NAME + " " + student.LAST_NAME
                          }
                        }),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(
                            _vm._s(student.FIRST_NAME) +
                              " " +
                              _vm._s(student.LAST_NAME)
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-7 col-md-6 student-info"
                      },
                      [
                        _vm._l(student.ENROLLMENT, function(enrollment) {
                          return _c("p", { key: enrollment.SCHOOL_ID }, [
                            _c("strong", [
                              _vm._v(_vm._s(enrollment.SCHOOL_TITLE))
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.commonContent.sideMenuGradeLabel"
                                  )
                                ) +
                                " "
                            ),
                            _c("strong", [
                              _vm._v(_vm._s(enrollment.GRADE_LEVEL))
                            ])
                          ])
                        }),
                        _vm._v(" "),
                        student.PORTAL_ACCESS_ALLOWED_FLG === "Y" &&
                        student.HAS_ACCOUNT === "Y"
                          ? _c(
                              "div",
                              { staticClass: "account-status" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: "check",
                                    "aria-hidden": "true"
                                  }
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.Students.studentHasAnAccount"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "divider" }),
          _vm._v(" "),
          _c("div", { staticClass: "row request-access" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("p", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.Students.portalAccessInformationalText"
                      )
                    ) +
                    "\n\t\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-backpack",
                  on: {
                    click: function($event) {
                      return _vm.requestAccess()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.Students.requestAccessToOtherStudentsTitleCase"
                        )
                      ) +
                      "\n\t\t\t\t"
                  )
                ]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }